export default __webpack_public_path__ + "static/media/Find-GH-Screely.d8466b3e.png";